import styled from "styled-components";

import theme from "@/constants/theme";

export const SearchForm = styled.form`
  position: relative;

  input {
    width: 100%;
    height: 50px;
    border-radius: 24px;
    box-sizing: border-box;
    margin-bottom: 10px;
    font-size: 20px;
    font-style: normal;
    font-weight: 300;
    text-align: left;
    padding-left: 20px;
    font-family: "Inter", sans-serif;
    color: ${theme.colors.black};
  }

  .search-icon {
    height: 50px;
    position: absolute;
    display: flex;
    align-items: center;
    top: 0px;
    right: 16px;
    font-size: 24px;
  }
`;
